import { jsx, jsxs } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import { CdnIcon } from "../CdnIcon/index.js";
import { ScrollArea } from "../ScrollArea/index.js";
import { Span } from "../Text/index.js";
function PopoverContent({ headingCustomSlot, headingCloseButtonSlot, headingLeftSlot, headingRightSlot, headingTextSlot, headingIconSlot, bodyTextSlot, renderCloseButton, headingCustomNode, headingText, headingIconName, headingRightNode, description, children, footer, headingClasses, scrollAreaClasses, contentClasses, bodyClasses, footerClasses }) {
    return /*#__PURE__*/ jsxs("div", {
        className: contentClasses,
        children: [
            headingCustomNode ? /*#__PURE__*/ jsx(Popover.Title, {
                children: /*#__PURE__*/ jsx("div", {
                    className: headingCustomSlot,
                    children: headingCustomNode
                })
            }) : headingText ? /*#__PURE__*/ jsxs("div", {
                className: headingClasses,
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: headingLeftSlot,
                        children: [
                            headingIconName && /*#__PURE__*/ jsx(CdnIcon, {
                                iconName: headingIconName,
                                size: "24",
                                className: headingIconSlot
                            }),
                            /*#__PURE__*/ jsx(Popover.Title, {
                                children: /*#__PURE__*/ jsx("div", {
                                    className: headingTextSlot,
                                    children: headingText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: headingRightSlot,
                        children: headingRightNode
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: headingCloseButtonSlot,
                        children: /*#__PURE__*/ jsx(Popover.Close, {
                            render: ()=>/*#__PURE__*/ jsx("div", {
                                    children: renderCloseButton()
                                })
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ jsxs(ScrollArea, {
                className: scrollAreaClasses,
                popoverBody: true,
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: bodyClasses,
                        children: [
                            description && /*#__PURE__*/ jsx(Popover.Description, {
                                children: /*#__PURE__*/ jsx(Span, {
                                    className: bodyTextSlot,
                                    children: description
                                })
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: footerClasses,
                        children: footer
                    })
                ]
            })
        ]
    });
}
export { PopoverContent };
